import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StoreProvider, rootStore } from '@/stores/RootStore';
import App from './App';
import '@/styles/global.scss';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <StoreProvider value={rootStore}>
      {/* 라우팅 도입(2026-08-02): 홈('/') + 회사소개('/company') 등 페이지 단위 라우팅.
          회사소개 자식(인사말·조직도…)은 별도 라우트가 아니라 /company 내부 섹션(#greeting 등)으로 앵커 스크롤. */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StoreProvider>
  </React.StrictMode>,
);
